import set from 'lodash/set'
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js'
import LanguageEnum from 'enums/language.enum'

const messages = require
    .context('./locales/', true, /^\.\/.*\.js$/)
    .keys()
    .reduce((messages, file) => {
        const locale = file.replace('./', '').replace('.js', '')

        set(messages, locale.split('/'), require(`./locales/${locale}`).default)

        return messages
    }, {})

export const allowedLocales = Object.keys(messages)
const language = localStorage.getItem('locale')
const i18n = createI18n({
    locale: language ? (Object.values(LanguageEnum).includes(language) ? language : LanguageEnum.SR) : LanguageEnum.SR,
    messages,
})

export default i18n
